<template>
    <select class='custom-select' @input="$emit('input', $event.target.value)">
        <option value="">{{ $t("details.form.select_placeholder") }}</option>
        <option :value="typeof item == 'object' ? item.id : item" v-for="item in field.items">{{ typeof item == 'object' ? item.name : item }}</option>
    </select>
</template>

<script>
export default {
    name : "InputSelect",
    props: {
        field: Object
    }
}
</script>
